import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { finalize, catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { AuthService } from "../../../authentication/oidc/auth.service";
import { ProjectService } from "../../service/project.service";
export const InterceptorSkipHeader = "X-Skip-Interceptor";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  apiNum: number = 0;
  loading = $("#showLoading");
  constructor(
    private authService: AuthService,
    private projectService: ProjectService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    try {
      let token: string = this.authService.getToken();

      if (req.headers.has(InterceptorSkipHeader)) {
        const headers = req.headers.delete(InterceptorSkipHeader);
        return next.handle(req.clone({ headers }));
      }

      if (!req.headers.has("Authorization") && token) {
        req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
        if (this.projectService.Current)
          req = req.clone({
            setHeaders: { ProjectId: this.projectService.Current },
          });
      }

      if (localStorage.getItem("language"))
        req = req.clone({
          setHeaders: { Language: localStorage.getItem("language") },
        });

      if (this.apiNum == 0 && !req.headers.has("HideLoading"))
        this.loading.css("display", "block");
      this.apiNum++;

      return next.handle(req).pipe(
        finalize(() => {
          if (--this.apiNum == 0) this.loading.css("display", "none");
        }),
        catchError((err) => {
          console.error(err);
          if (err.status == 401) {
            sessionStorage.clear();
            location.href = "/authentication/login";
          } else if (err.status == 500) {
            if (!(err.error instanceof Object)) {
              err.error = JSON.parse(err.error);
            }
          } else if (err.status == 400 || err.status == 404) {
            let error: any = {};
            error.Message = err.error;
            err.error = error;
          } else if (err.status === 0) {
            err.error.Message = "Unable to connect to server.";
          }
          return throwError(err);
        })
      );
    } catch (error) {
      return next.handle(req);
    }
  }
}
